import { render, staticRenderFns } from "./changeLanguage.vue?vue&type=template&id=1e4a4498&scoped=true&"
import script from "./changeLanguage.vue?vue&type=script&lang=js&"
export * from "./changeLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a4498",
  null
  
)

export default component.exports